import { render, staticRenderFns } from "./Projection.vue?vue&type=template&id=40a13e0e&"
import script from "./Projection.vue?vue&type=script&lang=ts&"
export * from "./Projection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports